import { createContext } from "react";
import { noOp } from "../../utils/noOp.js";
const initialState = { registeredModals: [], targetZIndex: 9999 }, FocusModalContext = createContext({ ...initialState, setRegisteredModals: noOp, setUnviewedCount: noOp });
export {
  FocusModalContext
};
//# sourceMappingURL=FocusModalContext.js.map
